import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/Login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login_Home" */ '../components/Login.vue'),    
  },
  {
    path: '/home',
    name: 'Home',
    redirect: '/welcome',
    component: () => import(/* webpackChunkName: "Login_Home" */ '../components/Home.vue'),
    children: [
      {
        path: '/welcome',
        name: 'Welcome',
        component: () => import(/* webpackChunkName: "Welcome" */ '../components/Welcome.vue')
      },
      {
        path: '/banner', 
        name: 'banner',
        component: () => import(/* webpackChunkName: "map" */ '../components/banner/banner.vue')
      }, 
      {
        path: '/skin', 
        name: 'skin',
        component: () => import(/* webpackChunkName: "map" */ '../components/skin/skin.vue')
      },       
      {
        path: '/typecolor', 
        name: 'typecolor',
        component: () => import(/* webpackChunkName: "map" */ '../components/typecolor/typecolor.vue')
      }       
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
